'use client';

import React, { type ComponentPropsWithoutRef } from 'react';
import { cx } from '@milanote/roma/utils/cx';
import { CommandMenuItemBase } from './command-menu-item-base';
import type { CommandMenuSize } from './command-menu.types';

const COMMAND_MENU_FOOTER_DISPLAY_NAME = 'RomaCommandMenuFooter';

const footerStyles = {
    root: 'shrink-0 border-t border-tertiary px-1.5 pt-1 pb-1.5',
    item: 'cursor-default rounded-none select-auto',
};

export type CommandMenuFooterProps = ComponentPropsWithoutRef<'div'> & {
    size?: CommandMenuSize;
};

/**
 * Displays footer content at the same vertical rhythm as command menu rows.
 */
export const CommandMenuFooter: React.FC<CommandMenuFooterProps> = ({ size = 'sm', className, children, ...props }) => (
    <div {...props} className={cx(COMMAND_MENU_FOOTER_DISPLAY_NAME, footerStyles.root, className)}>
        <CommandMenuItemBase size={size} className={footerStyles.item}>
            {children}
        </CommandMenuItemBase>
    </div>
);

CommandMenuFooter.displayName = COMMAND_MENU_FOOTER_DISPLAY_NAME;
